export default __webpack_public_path__ + "static/media/Image-18.2edc9984.jpg";